// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary {
  color: #1779ba;
}
.secondary {
  color: #767676;
}
.success {
  color: #3adb76;
}
.warning {
  color: #ffae00;
}
.alert {
  color: #cc4b37;
}
.small {
  position: absolute;
  top: '-10px';
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/FAIcon.less"],"names":[],"mappings":"AAEA;EAAU,cAAA;AAAV;AACA;EAAY,cAAA;AAEZ;AADA;EAAU,cAAA;AAIV;AAHA;EAAU,cAAA;AAMV;AALA;EAAQ,cAAA;AAQR;AAPA;EAAQ,kBAAA;EAAoB,YAAA;AAW5B","sourcesContent":["\n\n.primary {color: #1779ba}\n.secondary {color: #767676}\n.success {color: #3adb76}\n.warning {color: #ffae00}\n.alert {color: #cc4b37}\n.small {position: absolute; top: '-10px'; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
